import { Injectable, Inject } from '@angular/core';

import { ConfigurationsService } from '../configurations/configurations.service';
import { map, withLatestFrom } from 'rxjs/operators';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared/config';
import { WindowActiveConfiguration } from '@icc/window-door/types';
import { currencyExchange, Issue } from '@icc/shared/helpers';
import { SharedFacade } from './shared.facade';
import { Store } from '@ngrx/store';
import { fromSharedActions } from './shared.actions';
import '@icc/garage-door/types';
import '@icc/awning/types';
import '@icc/coupled-window/types';

@Injectable()
export class ConfiguratorFacade {
    constructor(
        private configurationsService: ConfigurationsService,
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private sharedFacade: SharedFacade,
        private store: Store<any>
    ) {}

    price$ = this.configurationsService.configuration$.pipe(
        withLatestFrom(this.sharedFacade.currency$),
        map(([conf, currency]) => ({
            showPrice: (
                    WindowActiveConfiguration.is(conf)
                    && conf.Sashes.length > 0
                    && !conf.ChangedDimensions
                    && (this.config().preset === 'b2c' ? !this.config().hidePricesInB2cConfigurator : true)
                )
                || (
                    (this.config().preset === 'b2c' ? !this.config().hidePricesInB2cConfigurator : true)
                    &&
                    (conf.type === 'roller_shutter'
                    || conf.type === 'external_blind')
                    && conf.RollerShutter.shutters.length > 0
                )
                || (
                    (this.config().preset === 'b2c' ? !this.config().hidePricesInB2cConfigurator : true)
                    && (conf.type === 'accessory'
                    || conf.type === 'garage_door'
                    || conf.type === 'awning'
                    || conf.type === 'complementary_goods'
                    || conf.type === 'mosquito'
                    || conf.type === 'coupled_window')
                ),
            price:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C
                    ? conf.PriceGross
                    : conf.Price,
            priceBeforePromotions:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C
                    ? conf.PriceGrossBeforePromotions
                    : conf.PriceBeforePromotions,
            priceAfterDiscountsInCurrency:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C
                    ? conf.PriceGrossAfterDiscounts
                    : conf.PriceAfterDiscountsInCurrency,
            listPrice:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C
                    ? conf.ListPriceGross
                    : conf.ListPrice,
            listPriceBeforePromotions:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C
                    ? conf.ListPriceGrossBeforePromotions
                    : conf.ListPriceBeforePromotions,
            listPriceAfterDiscountsInCurrency:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C
                    ? conf.ListPriceGrossAfterDiscounts
                    : conf.ListPriceAfterDiscountsInCurrency,
            discount: conf.Discount,
            listDiscount: conf.ListDiscount,
            promotion: Math.abs(conf.PriceBeforePromotions - conf.Price) > 2000 * Number.EPSILON ? (
                    this.config().preset === 'b2c'
                        && this.config().IccConfig.Configurators.grossPriceInSummaryB2C ?
                        currencyExchange(conf.PriceGrossBeforePromotions, currency) - conf.PriceGrossAfterDiscounts
                        : currencyExchange(conf.PriceBeforePromotions, currency, true) - conf.PriceAfterDiscountsInCurrency
                ) : 0,
            listPromotion: Math.abs(conf.ListPriceBeforePromotions - conf.ListPrice) > 2000 * Number.EPSILON ? (
                    this.config().preset === 'b2c'
                        && this.config().IccConfig.Configurators.grossPriceInSummaryB2C ?
                        currencyExchange(conf.ListPriceGrossBeforePromotions, currency) - conf.ListPriceGrossAfterDiscounts
                        : currencyExchange(conf.ListPriceBeforePromotions, currency, true) - conf.ListPriceAfterDiscountsInCurrency
                ) : 0,
            hasGrossPrice:
                this.config().preset === 'b2c'
                && this.config().IccConfig.Configurators.grossPriceInSummaryB2C,
        }))
    );
    issues$ = this.configurationsService.configuration$.pipe(map(conf => conf.Issues));

    SaveInformationDialog(payload: {
        issues: Issue[],
        isBlockedAddToOffer: boolean,
        message?: string
    }) {
        this.store.dispatch(
            new fromSharedActions.SaveInformationDialog(
                payload,
            )
        );
    }
}
